import { useEffect, useMemo, useRef, useState } from 'react';
import AuthenticationUtil from '../../../util/AuthenticationUtil';
import SelectionBox from '../../../component/SelectionBox';
import { CODE_GROUP_ID } from '../../../constant/Constant';
import CodeUtil from '../../../util/CodeUtil';
import ExcelDownloadButtonBox from '../../../component/buttons/ExcelDownloadButtonBox';
import ExcelUploadButtonBox from '../../../component/buttons/ExcelUploadButtonBox';
import EnrolmentStatusStudentModal from '../../modal/EnrolmentStatusStudentModal';
import { modalType } from '../../../util/ModalUtil';
import ModalRef from '../../../component/ModalRef';
import { useDispatch, useSelector } from 'react-redux';
import {
    actionExcelDownload,
    actionExcelUpload,
    actionSearch,
    actionEdit,
} from '../../../module/body/semester/SemesterEnrolmentStatusViewTab1BodyModule';
import StatusTextIconBox from '../../../component/StatusTextIconBox';
import SearchButtonBox from '../../../component/buttons/SearchButtonBox';
import SessionStorageUtil from '../../../util/SessionStorageUtil';
import TableBox from '../../../component/TableBox';
import { handleControl, defaultGridData, initGrid } from '../../../module/component/TableBoxModule';
import NullCheckUtil from '../../../util/NullCheckUtil';
import FormatUtil from '../../../util/FormatUtil';
import { IconButton, Tooltip } from '@material-ui/core';
import { OpenEditIcon } from '../../../component/icon/GridIcons';
import PathUtil from '../../../util/PathUtil';
import qs from 'qs';
import { useLocation } from 'react-router-dom';
import PopupRef from '../../../component/PopupRef';
import InputBox from '../../../component/InputBox';

const ConditionArea = ({ tabNo, popupRef, modalRef }) => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const lessonUniversityCd = AuthenticationUtil.getUserUniversityCd();
    const [semesterId, setSemesterId] = useState('');
    const [userUniversityCd, setUserUniversityCd] = useState('');
    const [enrolmentValidStatusCd, setEnrolmentValidStatusCd] = useState('');
    const [lessonUniversityStudentIdRegStatusCd, setLessonUniversityStudentIdRegStatusCd] = useState('');
    const [userNm, setUserNm] = useState('');
    const [params, setParams] = useState({});

    const dispatch = useDispatch();

    const { gridData } = useSelector((state) => state.tableBoxState);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );

        queryData.semesterId == undefined
            ? setSemesterId(SessionStorageUtil.getCurrentSemesterId())
            : setSemesterId(queryData.semesterId);
        queryData.userUniversityCd && setUserUniversityCd(queryData.userUniversityCd);
        queryData.enrolmentValidStatusCd && setEnrolmentValidStatusCd(queryData.enrolmentValidStatusCd);
        queryData.lessonUniversityStudentIdRegStatusCd &&
            setLessonUniversityStudentIdRegStatusCd(queryData.lessonUniversityStudentIdRegStatusCd);
        queryData.userNm && setUserNm(queryData.userNm);

        onClick({
            semesterId:
                queryData.semesterId == undefined ? SessionStorageUtil.getCurrentSemesterId() : queryData.semesterId,
            userUniversityCd: queryData.userUniversityCd,
            lessonUniversityCd,
            enrolmentValidStatusCd: queryData.enrolmentValidStatusCd,
            lessonUniversityStudentIdRegStatusCd: queryData.lessonUniversityStudentIdRegStatusCd,
            userNm: queryData.userNm,
            page: NullCheckUtil.isNotNull(queryData.page) ? queryData.page : defaultGridData.page,
            pageSize: NullCheckUtil.isNotNull(queryData.pageSize) ? queryData.pageSize : 100,
        });

        return () => {
            dispatch(initGrid());
        };
    }, []);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );
    }, [params]);

    const onChangePageInfo = (page, pageSize) => {
        onClick({
            ...params,
            page,
            pageSize,
        });
    };

    const onClick = (params) => {
        setParams(params);
        dispatch(
            actionSearch({
                params,
                callback: (result) => {
                    if (result.totalCount == 0) {
                        popupRef.current.openAlert('조회된 결과가 없습니다.');
                    }
                },
            }),
        );
        PathUtil.pushState(location.pathname, { ...params, tabNo });
    };

    const onRowDoubleClick = (row, params) => {
        modalRef.current.open(
            <EnrolmentStatusStudentModal
                module={actionEdit}
                row={row}
                type={modalType.EDIT}
                modalRef={modalRef}
                isUserUniversityCheck={false}
                callback={() => {
                    onClick(params);
                }}
            />,
            'medium',
        );
    };

    const handleDownload = () => {
        dispatch(actionExcelDownload({ params }));
    };

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            onClick({
                semesterId,
                userUniversityCd,
                lessonUniversityCd,
                enrolmentValidStatusCd,
                lessonUniversityStudentIdRegStatusCd,
                userNm,
                page: defaultGridData.page,
                pageSize: gridData.pageSize,
            });
        }
    };

    const columns = useMemo(
        () => [
            {
                field: 'semesterId',
                headerName: '학기',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) => CodeUtil.getCodeName(CODE_GROUP_ID.SEMESTER, params.row.semesterId),
            },
            {
                field: 'userUniversityNm',
                headerName: '소속대학',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'userNm',
                headerName: '이름',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'userId',
                headerName: '사용자ID',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'telNo',
                headerName: '연락처',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) => FormatUtil.phoneFormatter(params.row.telNo),
            },
            {
                field: 'enrolmentValidStatusCd',
                headerName: '본교수강자격검증',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) => (
                    <StatusTextIconBox
                        codeGroup={CODE_GROUP_ID.ENROLMENT_VALID_STATUS}
                        statusCd={params.row.enrolmentValidStatusCd}
                    />
                ),
            },
            {
                field: 'preLessonYn',
                headerName: '과거 수강여부',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'preLessonUniversityStudentId',
                headerName: '과거 개설대학학번',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'lessonUniversityStudentId',
                headerName: '개설대학학번',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'lessonUniversityNoticeMsg',
                headerName: '개설대학안내메시지',
                headerAlign: 'center',
                align: 'left',
                tooltip: true,
                flex: 20,
            },
            {
                field: 'detail',
                headerName: '기능',
                headerAlign: 'center',
                align: 'center',
                flex: 6,
                disableColumnMenu: true,
                hideSortIcons: true,
                disableExport: true,
                renderCell: (item) => (
                    <>
                        <Tooltip title='수정'>
                            <IconButton onClick={() => onRowDoubleClick(item.row, params)}>
                                <OpenEditIcon />
                            </IconButton>
                        </Tooltip>
                    </>
                ),
            },
        ],
        [params],
    );

    return (
        <div className='tab-body'>
            <div className='con-form-wrap'>
                <div className='board-inner'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='form-box-container'>
                                <SelectionBox
                                    title='학기'
                                    value={semesterId}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.SEMESTER)}
                                    onChange={(e) => setSemesterId(e.target.value)}
                                    useAll={true}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <SelectionBox
                                    title='소속대학'
                                    w140
                                    value={userUniversityCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY)}
                                    onChange={(e) => setUserUniversityCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <SelectionBox
                                    title='본교수강자격검증'
                                    w140
                                    value={enrolmentValidStatusCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.ENROLMENT_VALID_STATUS)}
                                    onChange={(e) => setEnrolmentValidStatusCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <SelectionBox
                                    title='개설대학ID발급상태'
                                    w140
                                    value={lessonUniversityStudentIdRegStatusCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.ID_REG_STATUS)}
                                    onChange={(e) => setLessonUniversityStudentIdRegStatusCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <InputBox
                                    title='이름'
                                    value={userNm}
                                    onChange={(e) => setUserNm(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox
                                    title='조회'
                                    onClick={(e) =>
                                        onClick({
                                            semesterId,
                                            userUniversityCd,
                                            lessonUniversityCd,
                                            enrolmentValidStatusCd,
                                            lessonUniversityStudentIdRegStatusCd,
                                            userNm,
                                            page: defaultGridData.page,
                                            pageSize: gridData.pageSize,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='con-tb-wrap'>
                <div className='con-tb-title  '>
                    <h3 className='tb-tit-name'>학점교류 학생 목록</h3>
                    <div className='btn-group'>
                        <ExcelDownloadButtonBox onClick={(e) => handleDownload()} />
                        <ExcelUploadButtonBox
                            params={{ semesterId, lessonUniversityCd }}
                            callback={(e) => {
                                onClick({
                                    semesterId,
                                    userUniversityCd,
                                    lessonUniversityCd,
                                    enrolmentValidStatusCd,
                                    lessonUniversityStudentIdRegStatusCd,
                                    userNm,
                                    page: defaultGridData.page,
                                    pageSize: gridData.pageSize,
                                });
                            }}
                            module={actionExcelUpload}
                        />
                    </div>
                </div>
                <div className='comment-box'>
                    <ul>
                        <li>본교(소속대학)의 수강신청 검증이 완료된 이후에 처리 가능합니다. </li>
                        <li>학점교류 수강신청한 타교 학생을 확인하고 개설대학의 학번을 발급합니다. </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

const SemesterEnrolmentStatusViewTab1Body = ({ tabNo }) => {
    const modalRef = useRef(null);
    const popupRef = useRef(null);

    return (
        <div>
            <ConditionArea tabNo={tabNo} popupRef={popupRef} modalRef={modalRef} />
            <TableBox />
            <PopupRef ref={popupRef} />
            <ModalRef ref={modalRef} />
        </div>
    );
};

export default SemesterEnrolmentStatusViewTab1Body;
